module.exports = __webpack_public_path__ + "static/fonts/Lato-Regular.3b9b990.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/font/Lato-Regular.ttf
// module id = iJZZ
// module chunks = 27